/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpageemailcopied3Inputs */

const en_ticketpageemailcopied3 = /** @type {(inputs: Ticketpageemailcopied3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email copied`)
};

const de_ticketpageemailcopied3 = /** @type {(inputs: Ticketpageemailcopied3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail kopiert`)
};

/**
* | output |
* | --- |
* | "Email copied" |
*
* @param {Ticketpageemailcopied3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpageemailcopied3 = /** @type {((inputs?: Ticketpageemailcopied3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpageemailcopied3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpageemailcopied3(inputs)
	return de_ticketpageemailcopied3(inputs)
});
export { ticketpageemailcopied3 as "ticketPageEmailCopied" }